module.exports = __webpack_public_path__ + "images/little-check.svg";